import styled from "styled-components";

import Loader from "components/Layout/Loader";
import { COLORS } from "constants/colorScheme";

export const CategoryCardWrapper = styled.div`
  :not(:last-child) {
    margin-bottom: 32px;
  }
`;

export const ScrollLoader = styled(Loader)`
  height: 100px;
`;

export const OverflowLoader = styled(Loader)`
  position: absolute;
  z-index: 10;

  background-color: ${COLORS.WHITE_40};
`;

export const PageControl = styled.div`
  :not(:last-child) {
    margin-right: 40px;
  }
`;

export const FilterContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;

  width: 100%;

  margin-bottom: 30px;
`;
